<section class="surface-elevated p-6 sm:p-8" style="opacity: 1; transform: none;">
    <h2 class="mb-6 flex items-center gap-2 text-2xl font-semibold text-text-primary">
        <i class="fas fa-star text-xl text-primary"></i>
        {{ 'experts.reviews.title' | translate }} ({{ expert?.reviewsCount || 0 }})
    </h2>
    @if (!expert?.reviewsCount) {
        <div class="rounded-lg border border-border-subtle bg-surface p-8 text-center">
            <i class="fas fa-star mb-4 text-4xl text-text-muted opacity-50"></i>
            <h3 class="mb-2 font-semibold text-text-primary">{{ 'experts.reviews.emptyTitle' | translate }}</h3>
            <p class="text-sm text-text-secondary">{{ 'experts.reviews.emptyDescription' | translate }}</p>
        </div>
    }
</section>
